import { dateFormatedToDB } from "../../functions";
import { PetsReportModel } from "../../models/reports";

export default class PetsReportController {
  constructor() {
    this.name = "reports-pets";
    this.tableName = `${this.name}-table`;
    this.paginationName = `${this.name}-pagination`;

    this.MPetsReport = PetsReportModel();
    this.init();
  }

  init = async () => { this.findPetsReport(); };

  findPetsReport = async () => { await this.MPetsReport.findPetsReport(); };

  setPage = (page) => { this.MPetsReport.setPage(page); };

  setFilter = (filterData) => {
    const filter = { ...filterData };
    if ("dateFrom" in filter) filter.dateFrom = dateFormatedToDB(filter.dateFrom);
    if ("dateTo" in filter) filter.dateTo = dateFormatedToDB(filter.dateTo);
    this.MPetsReport.setFilter(filter);
  };

  clearFilter = async () => {
    this.MPetsReport.setFilter({
      hasPackage: "*",
      isSubscriber: "*",
      minAbsenceDays: "30",
      cpf: "",
      search: "",
    });
    await this.filterPets();
  };

  /** KPI como atalho de filtro: clicar aplica, clicar de novo limpa. */
  toggleFilter = async (key, value) => {
    const current = this.MPetsReport.currentFilter()[key];
    this.MPetsReport.setFilter({ [key]: current === value ? "*" : value });
    await this.filterPets();
  };

  /** Table.Header chama onSort(sortKey) com UM argumento; a direcao alterna aqui. */
  handleSortColumn = async (sortBy) => {
    const current = this.MPetsReport.currentSort();
    const sortOrder = current.sortBy === sortBy && current.sortOrder === "asc" ? "desc" : "asc";
    this.MPetsReport.setSort({ sortBy, sortOrder });
    await this.filterPets();
  };

  filterPets = async (e) => {
    if (e) e.preventDefault();
    await this.MPetsReport.filterPetsReport();
  };

  reportExport = () => { this.MPetsReport.export(); };
}
